// extracted by css-extract-rspack-plugin
export default {"FallbackContainer":"FallbackContainer-C1wWnB","fallbackContainer":"FallbackContainer-C1wWnB","Fallback":"Fallback-geWp3p","fallback":"Fallback-geWp3p"};